import * as actionTypes from './actionTypes'
import axios from '../../axios-puzzles'
import axiosdb from '../../axios-games'

export const setPuzzle = puzzle => {
  return {
    type: actionTypes.SET_PUZZLE,
    puzzle
  }
}

export const initPuzzle = (game, puzzleWordCount) => {
  return dispatch => {
    axios.get(`/puzzle?wordCount=${puzzleWordCount}`).then(res => {
      const gamePuzzle = res.data.puzzle
      game.updateGame(gamePuzzle)
      dispatch(setPuzzle(gamePuzzle))
      console.log(gamePuzzle)
    })
  }
}

export const keyPress = (letterIndex) => {
  return {
    type: actionTypes.KEY_PRESS,
    letterIndex
  }
}

export const keyPressInit = (game, alphabet) => {
  return dispatch => {
    window.addEventListener('keypress', e => {
      // End game if player is out of guesses
      if (game.status !== 'playing') {
        return
      }  
  
      //Check if characters other than letters were pressed
      if (e.charCode <= 64 || e.charCode >= 123) {
        console.log('Only letters are allowed')
        return
      } else if (e.charCode >= 91 && e.charCode <= 96) {
        console.log('Only letters are allowed')
        return
      }
  
      // Convert keypress to letter click
      const inputIndex = alphabet.findIndex(el => {
        return el.letter === e.key.toUpperCase()
      })
      dispatch(keyPress(inputIndex))
    })
  }
}

export const updateAlphabet = clickedLetterIndex => {
  return {
    type: actionTypes.UPDATE_ALPHABET,
    clickedLetterIndex
  }
}

export const updateStatusMessage = () => {
  return {
    type: actionTypes.UPDATE_STATUS_MESSAGE,
  }
}

export const setCurrentLetter = letter => {
  return {
    type: actionTypes.SET_CURRENT_LETTER,
    letter
  }
}

export const setCurrentNumberOfCorrectLetters = currentNumberOfCorrectLetters => {
  return {
    type: actionTypes.SET_CURRENT_NUMBER_OF_CORRECT_LETTERS,
    currentNumberOfCorrectLetters
  }
}

export const saveGameToDatabase = (game, correctGuessesCount, incorrectGuessesCount) => {
  const isWinner = game.status === 'finished'
    const outcome = isWinner ? 1 : 0
    const savedGame = {
      outcome,
      puzzle: game.solution,
      puzzleSize: game.puzzle.length - 2,
      correctGuesses: correctGuessesCount,
      incorrectGuesses: incorrectGuessesCount,
    }
    axiosdb.post('games.json', savedGame)
      .then(res => console.log(savedGame))
      .catch(err => console.log(err))
  return {
    type: actionTypes.SAVE_GAME_TO_DATABASE,
    game
  }
}